var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1649 9.40495H10.5935V5.83352C10.5935 5.67565 10.5308 5.52425 10.4191 5.41262C10.3075 5.30099 10.1561 5.23828 9.99823 5.23828C9.84037 5.23828 9.68896 5.30099 9.57734 5.41262C9.46571 5.52425 9.40299 5.67565 9.40299 5.83352V9.40495H5.83157C5.6737 9.40495 5.5223 9.46766 5.41067 9.57929C5.29904 9.69092 5.23633 9.84232 5.23633 10.0002C5.23633 10.1581 5.29904 10.3095 5.41067 10.4211C5.5223 10.5327 5.6737 10.5954 5.83157 10.5954H9.40299V14.1669C9.40299 14.3247 9.46571 14.4761 9.57734 14.5877C9.68896 14.6994 9.84037 14.7621 9.99823 14.7621C10.1561 14.7621 10.3075 14.6994 10.4191 14.5877C10.5308 14.4761 10.5935 14.3247 10.5935 14.1669V10.5954H14.1649C14.3228 10.5954 14.4742 10.5327 14.5858 10.4211C14.6974 10.3095 14.7601 10.1581 14.7601 10.0002C14.7601 9.84232 14.6974 9.69092 14.5858 9.57929C14.4742 9.46766 14.3228 9.40495 14.1649 9.40495Z",
    fill: "#875B52"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#875B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0b10e43c5c5680f5e24c12e9c98c7fdc.svg";
export { ForwardRef as ReactComponent };